import moment from 'moment';

/**
 * Format the given date.
 */
const date = (value, format, tz) => {
    if (format === undefined) {
        format = 'MMMM Do, YYYY';
    }

    if (tz !== undefined && tz !== null) {
        return moment.utc(value).tz(tz).format(format);
    }

    return moment.utc(value).local().format(format);
};

/**
 * Format the given date.
 */
const time = (value, format) => {
    if (format === undefined) {
        format = 'h:mm A';
    }

    return moment(value, 'HH:mm').format(format);
};

const limit = (value, length) => {
    if (!value) {
        return value;
    } else if (value.length > length) {
        return value.substring(0, length) + '...';
    } else {
        return value;
    }
};

const inboxesLimit = (value) => {
    if (!value) {
        return value;
    } else if (String(value).length > 2) {
        return '99+';
    } else {
        return value;
    }
};

/**
 * Format the given date as a timestamp.
 */
const datetime = (value, format, tz) => {
    if (format === undefined) {
        format = 'D MMM, YYYY - h:mm A';
    }

    if (tz !== undefined && tz !== null) {
        return moment.utc(value).tz(tz).format(format);
    }
    return moment.utc(value).local().format(format);
};

/**
 * Converts the given value into a formatted currency output.
 *
 * @param {int} value
 * @param {int} floatLength
 * @param {boolean} showSymbol
 * @return {*}
 */
const currency = (value, floatLength) => {
    value = value / 100;

    if (floatLength === undefined) {
        floatLength = 2;
    }

    value = parseFloat(value);

    if (!isFinite(value) || (!value && value !== 0)) {
        return '';
    }

    let string = Math.abs(value).toFixed(floatLength);
    let _int = floatLength ? string.slice(0, -1 - floatLength) : string;
    let i = _int.length % 3;
    let head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
    let _float = string.slice(-1 - floatLength);
    let sign = value < 0 ? '-' : '';

    if (!parseFloat(_float)) {
        _float = '.00';
    } else {
        _float = parseFloat(_float).toString().substring(1);

        if (_float.length < floatLength) {
            _float += new Array(floatLength - _float.length + 1).join('0');
        } else if (_float.length > 2) {
            while (_float.length > 2) {
                if (_float.slice(-1) === '0') {
                    _float = _float.slice(0, -1);
                } else {
                    break;
                }
            }
        }
    }

    return (
        sign +
        '$' +
        head +
        _int.slice(i).replace(/(\d{3})(?=\d)/g, '$1,') +
        (floatLength > 0 ? _float : '')
    );
};

/**
 * Format the given value to a number. (number_format for PHP).
 *
 * @param {String} value
 * @return {String}
 */
const number = (value) => {
    if (!value) {
        value = 0;
    }

    return parseInt(value.toString().replace(/[^\d\-]/g, ''), 10).toLocaleString();
};

/**
 * Format the given value to a float.
 *
 * @param {String} value
 * @return {String}
 */
const floatNumber = (value, locale) => {
    if (!value) {
        value = 0;
    }

    return new Intl.NumberFormat(locale).format(value);
};

/**
 * Format the given date into a relative time.
 */
const relative = (value, locale) => {
    if (locale === undefined) {
        locale = 'en-short';
    }

    return moment.utc(value).local().locale(locale).fromNow();
};

/**
 * Convert the first character to upper case.
 */
const capitalize = (value) => {
    if (!value && value !== 0) {
        return '';
    }

    return value.toString().charAt(0).toUpperCase() + value.slice(1);
};

/**
 * Pads the left side of the string with the given pad value.
 *
 * @param {String} value
 * @param {Number} width
 * @param {String} pad
 * @return {String}
 */
const lpad = (value, width, pad) => {
    pad = pad || '0';
    value = value + '';

    if (value.length >= width) {
        return value;
    } else {
        return new Array(width - value.length + 1).join(pad) + value;
    }
};

/**
 * Pads the right side of the string with the given pad value.
 *
 * @param {String} value
 * @param {Number} width
 * @param {String} pad
 * @return {String}
 */
const rpad = (value, width, pad) => {
    pad = pad || '0';
    value = value + '';

    if (value.length >= width) {
        return value;
    } else {
        return value + new Array(width - value.length + 1).join(pad);
    }
};

/**
 * Prepends a zero onto the month value if it less than 10.
 */
const expmonth = (value) => {
    value = parseInt(value);

    if (value < 10) {
        return `0${value}`;
    } else {
        return value;
    }
};

const capitalizeFirstLetter = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1);
};

const toTime = (value) => {
    return value;
};

const toDate = (value) => {
    return value;
};

const formatDate = (value) => {
    return value;
};

export default {
    date: date,
    time: time,
    limit: limit,
    inboxesLimit: inboxesLimit,
    datetime: datetime,
    currency: currency,
    number: number,
    floatNumber: floatNumber,
    relative: relative,
    capitalize: capitalize,
    lpad: lpad,
    rpad: rpad,
    expmonth: expmonth,
    capitalizeFirstLetter: capitalizeFirstLetter,
    toTime: toTime,
    toDate: toDate,
    formatDate: formatDate,
};
